import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { pieChartOptions } from '../../utils/charts';

interface PieChartProps {
  labels: string[];
  data: number[];
  backgroundColor?: string[];
  options?: any;
}

const PieChart: React.FC<PieChartProps> = ({ labels, data, backgroundColor, options }) => {
  const chartData = {
    labels,
    datasets: [
      {
        label: 'Data',
        data,
        backgroundColor: backgroundColor || [
          'rgba(106, 206, 114, 0.8)',
          'rgba(67, 67, 67, 0.8)',
        ],
        hoverOffset: 4,
      },
    ],
  };

  return <Doughnut data={chartData} options={options || pieChartOptions} />;
};

export default PieChart;

